import "../assets/css/benefits.css";

function StandardFlow(props) {

    return (<>
        <div dangerouslySetInnerHTML={{ __html: props.reward.description }}></div>
        {props.reward.extra_data.reward_code &&
            <div className="modal-code">
                {props.reward.extra_data.reward_code}
            </div>
        }
    </>);
}

export default StandardFlow;
